<template>
  <div>
    <div>
      <NavBarOnly></NavBarOnly>
      <div class="conteudo cor-secundaria-bg" style="position: unset;">
        <logo-empresa></logo-empresa>
        <h6>Validação realizada com sucesso! <br> Aproveite suas compras.</h6>
        <br>
        <div class="btn waves-effect waves-light cor-primaria-bg" @click="AbrirCardapio()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              Voltar para nosso Cardápio
            </div>
          </div>
       </div>
       <div style="height: 500px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBarOnly from "../../Widgets/NavBarOnly";
import LogoEmpresa from "../../Widgets/LogoEmpresa";

export default {
  name: "CadastroRealizadoSucesso",
  components: {
    LogoEmpresa,
    NavBarOnly
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    AbrirCardapio() {
      this.$router.push("/" + this.$store.state.empresa_url);
    }
  }
};
</script>

<style scoped>
  @import '../../../assets/css/conteudo-splash.css';
</style>



// WEBPACK FOOTER //
// src/components/Paginas/AreaCliente/CadastroRealizadoSucesso.vue